module.exports = __webpack_public_path__ + "img/Menu-icon.cf2ff005.svg";